import React from "react";
import { useForm } from "react-hook-form";
import { Form, Button } from "semantic-ui-react";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";

// Layout
import ModalFormLayout from "../Layouts/ModalFormLayout";

// Actions
import { newIngredient } from "../../redux/ingredients/ingredients.actions";
import { closeFormModal } from "../../redux/modals/modals.actions";
import { units } from './helpers';


const IngredientNewForm = () => {
  const { register, handleSubmit, errors } = useForm();

  const { loading, success } = useSelector((state) => state.ingredients);
  const dispatch = useDispatch();

  const onSubmit = (data) => {
    dispatch(newIngredient(data));
  };

  if (success) {
    toast.success(success);
    dispatch(closeFormModal());
  }

  return (
    <ModalFormLayout title="New Ingredient">
      <Form
        noValidate
        size="large"
        loading={loading}
        onSubmit={handleSubmit(onSubmit)}
      >
        <Form.Field required>
          <label>Name</label>
          <input
            type="text"
            name="name"
            ref={register({
              required: true,
            })}
          />
          {errors.name && errors.name.type === "required" && (
            <p>Name is required</p>
          )}
        </Form.Field>
        <Form.Field required>
          <label>Daily value</label>
          <input
            type="text"
            name="dailyValue"
            ref={register({
              required: false,
            })}
          />
          {errors.dailyValue && errors.dailyValue.type === "required" && (
            <p>Daily value</p>
          )}
        </Form.Field>
        <Form.Field required>
          <label>Unit</label>

          <select
            name="unit"
            ref={register({
              required: true,
            })}
          >
            <option value=""></option>
            {
              units.map((unit) => {
                return (
                  <option key={unit.name} value={unit.value}>{unit.name}</option>
                )
              })
            }
          </select>
        </Form.Field>
        {errors.unit && errors.unit.type === "required" && (
          <p>Unit is required</p>
        )}
        <Button primary type="submit" fluid>
          Save
        </Button>
      </Form>
    </ModalFormLayout>
  );
};

export default IngredientNewForm;
